import { createSelector } from 'utils/app.util';

const getSMLocationsSelector = (state) => state.getIn(['entity', 'smlocation']);

export const getSMLocationsFromState = createSelector(
  getSMLocationsSelector,
  (smLocations) => smLocations,
);
